module.exports = [{"type":"title","text":"2025-02-10"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USDT-Margined: The ‘Current All Open Orders’ API has added the 'actPrice' field."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-02-10.json
// module id = rMBC
// module chunks = 3